const Container = { position: 'absolute' };
const Button = {
  position: 'relative',
  transform: 'translate(-11%, -510%)',
  left: '40%',
};
const Link = { textDecoration: 'none', color: 'white' };

const style = {
  Container,
  Button,
  Link,
};

export default style;
